import * as z from 'zod/v4';
export {
  getEventsSchema,
  getEventsSummarySchema,
  createEventSchema,
  createEventSchemaBody,
  getEventSchema,
  getEventByCanonicalIdSchema,
  updateEventSchema,
  deleteEventSchema,
  scheduleSectionSchema,
  hudIconSchema,
  badgeSchema,
  fullScreenSchema,
  tileSchema,
  userTargetingSectionSchema,
  notificationSectionSchema,
  rewardSectionSchema,
  getEventComponentsSchema,
  purchaseSectionSchema,
  externalGetEventsQuery,
  externalGetEventsSchema,
  externalEventSchema,
  targetSchema,
  userBaseTargetSchema,
  chainOfferTileSchema,
  chainOfferSectionSchema,
  priceSchema,
  createBaseEventSchemaBody,
  getEventComponentsByType,
  localizedStringSchema,
  GATCHA_TYPE_VALUES,
  MODES_REQUIRING_ELEMENT,
  parentInheritFieldsSchema,
  JIGGLE_TYPE_VALUES,
  getChildEventsSchema,
  bulkCopyEventsSchema,
  duplicateEventSchema,
  scheduleRecurringEventsSchema,
  carnivalProgressRewardBarSchema,
  carnivalSectionSchema,
  carnivalDayConfigItemSchema,
  ITEM_TIER_VALUES,
  boxedGachaSectionSchema,
  modesOpenSectionSchema,
  COST_SOURCE_VALUES,
  costReductionsSectionSchema,
  additionalModeChancesSectionSchema,
  leaderboardLeagueSchema,
} from './events';
export { usersSchemas } from './users';
export { translationsSchemas } from './translations';
export { environmentsSchema } from './environments';
export { gameServersSchemas } from './game-servers';
export {
  createTemplateSchema,
  updateTemplateSchema,
  deleteTemplateSchema,
  getTemplateSchema,
  getTemplatesSchema,
  templateSchema,
  createTemplateBaseSchemaBody,
} from './templates';
export type {
  CreateTemplate,
  UpdateTemplate,
  GetTemplate,
  GetTemplatesQuery,
  Template,
} from './templates';

export type {
  Translation,
  CreateTranslation,
  UpdateTranslation,
  GetTranslationsQuery,
} from './translations';
export type { LoginBody, User, CreateUser, UpdateUser } from './users';
export type {
  ScheduleSchema,
  SchedulePermanentSchema,
  ScheduleNonPermanentSchema,
  TileSchema,
  GatchaProgressRewardBarSchema,
  SimpleConfigSchema,
  GatchaSectionSchema,
  CarnivalProgressRewardBarSchema,
  CarnivalSectionSchema,
  CarnivalDayConfigItemSchema,
  BoxedGachaSectionSchema,
  EventBoxSectionSchema,
  EventOverrideSchema,
  CardDisplaySectionSchema,
  ExternalGetEventsQuery,
  BadgeSchema,
  RewardMessageSchema,
  GrowthFundTierSchema,
  CrayonExternalEvent,
  ExternalEventError,
  CreateEvent,
  EventBase,
  CrayonEvent,
  EventMini,
  EventComponents,
  GetEventsQuery,
  UpdateEvent,
  RewardSchema,
  PushNotificationSchema,
  StringEnum,
  GatchaType,
  EnumParams,
  RelationEnum,
  UserTargeting,
  SingleTarget,
  TargetKeys,
  RelationTarget,
  LocalizedString,
  ImageSchema,
  ImageType,
  RewardItemSchema,
  PriceSchema,
  ChainOfferSchema,
  ChainOfferTileSchema,
  StepUpOfferOfferSchema,
  EventTaskSchema,
  LeaderboardTaskItemSchema,
  DisplaySchema,
  DeadLetterQueue,
  ExchangeShopSchema,
  EventQuestSchema,
  EventCurrencySchema,
  UserTargetingSectionSchema,
  PushNotificationSectionSchema,
  EventLeaderboardComponentsSchema,
  EventLeaderboardSectionSchema,
  EventLeaderboardLeague,
  ModesOpenSectionSchema,
  CostReductionsSectionSchema,
  AdditionalModeChancesSectionSchema,
} from './events';
export type { GameServerEnumTypes } from './game-servers';
export type { Environment } from './environments';

export type {
  ExperimentVariant,
  GetExperimentsQuery,
  CreateExperiment,
  UpdateExperiment,
  Experiment,
} from './experiments';
export {
  experimentVariantSchema,
  experimentSchema,
  createExperimentSchemaBody,
  createExperimentSchema,
  updateExperimentSchema,
  getExperimentSchema,
  getExperimentsSchema,
  deleteExperimentSchema,
} from './experiments';

export {
  IMAGE_TYPE_VALUES,
  LOCALIZED_STRING_TYPE_VALUES,
  ITEM_ENUM,
  RESOURCE_ENUM,
  HERO_ENUM,
  GEAR_ENUM,
  BOX_ENUM,
  RELATION_ENUM_VALUES,
  PURCHASE_CONSTRAINT_ENUM,
  TASK_TYPE_COUNTER,
  TASK_TYPE_LEADERBOARD,
  COUNTRIES,
} from './events';

z.config({
  customError: issue => {
    if (issue.code === 'invalid_type' && issue.received === 'undefined') {
      return { message: 'Field is required' };
    }
  },
});
